import { render, staticRenderFns } from "./MealConfiguration.vue?vue&type=template&id=5a31fe91&scoped=true"
import script from "./MealConfiguration.vue?vue&type=script&lang=js"
export * from "./MealConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31fe91",
  null
  
)

export default component.exports